<ion-item lines="full">
  <ion-title class="ion-no-padding ion-padding-vertical"
    ><b>{{ _title() | translate }}</b></ion-title
  >
  <ion-buttons slot="end">
    <ion-button (click)="dismissModal()"
      ><ion-icon name="close-outline"></ion-icon
    ></ion-button>
  </ion-buttons>
</ion-item>
<div class="ion-margin-bottom">
  <ion-grid class="ion-margin-top">
    <ion-row>
      <ion-col class="ion-text-center">
        <ion-icon name="close-circle" color="danger" class="icon-x3"></ion-icon>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="ion-text-center ion-padding-horizontal">
        {{ _message() | translate }}
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
<ion-footer>
  <div class="ion-text-center ion-padding">
    <ion-button
      id="showmoddel"
      color="primary"
      (click)="dismissModal()"
      align-self-center
      ><small>{{ 'general_close' | translate }}</small></ion-button
    >
  </div>
</ion-footer>
